import { AnchorButton, UL } from '@wheely/ui-kit';
import cn from 'classnames';
import { useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { useExternalLinks } from '@/app/hooks/useExternalLinks';
import { IntlContext } from '@/i18n';
import { getMyDriver } from '@/modules/driver/store/selectors';
import { CountryCode } from '@/shared/models/country-code';
import { getBookingLink } from '@/shared/utils/bookingLinksUtils';

import s from './AccountBlockedError.module.css';

const AccountBlockedError = () => {
  const { region } = useContext(IntlContext);
  const links = useExternalLinks();
  const driver = useSelector(getMyDriver);

  return (
    <>
      <FormattedMessage
        defaultMessage="Please get in touch with <a>the operations team</a> ({link})"
        id="XILJnT"
        description="Blocked account page description"
        values={{
          a: (text: React.ReactNode) => (
            <a href={`mailto:${links.contactOperationTeam}`} target="_blank" rel="noreferrer">
              {text}
            </a>
          ),
          link: links.contactOperationTeam,
        }}
      />
      {region === CountryCode.GreatBritain && (
        <div className={s.accreditationDetails}>
          <p>
            <FormattedMessage
              defaultMessage="If you have been contacted to book a re-accreditation session, please follow the next steps:"
              id="uoUvWI"
              description="Blocked account page description"
            />
          </p>
          <p>
            <FormattedMessage
              defaultMessage="Since January 2025, in order to be fully active on the platform you need to complete City Knowledge Test followed be two days of training."
              id="onboarding_intro_city_test_description_5"
              description="Blocked account page description"
            />
          </p>
          <p>
            <FormattedMessage
              defaultMessage="Please, ensure that:"
              id="1pueQw"
              description="GB Academy accreditation requirements description"
            />
          </p>
          <p>
            <UL>
              <FormattedMessage
                tagName="li"
                defaultMessage="You book the City Knowledge Test via the link provided below. Usually we have slots number of slots available across the week."
                id="KTYRiX"
                description="GB Academy accreditation requirement 1"
              />
              <FormattedMessage
                tagName="li"
                defaultMessage="The City Knowledge Test should be completed at the Wheely Academy in person. When you book a slot you will receive email with confirmation."
                id="0jX/Lm"
                description="GB Academy accreditation requirement 2"
              />
              <FormattedMessage
                tagName="li"
                defaultMessage="Subject to successfully completing the City Knowledge test, a member of Wheely Team at the Academy will book you for the next available accreditation session, which takes consequent 2 days."
                id="onboarding_intro_city_test_description_3"
                description="GB Academy accreditation requirement 3"
              />
              <FormattedMessage
                tagName="li"
                defaultMessage="Your account will be reactivated after completing re-accreditation."
                id="onboarding_intro_city_test_description_4"
                description="GB Academy accreditation requirement 4"
              />
            </UL>
          </p>
          <div className={s.buttons}>
            <AnchorButton
              href={getBookingLink(links.bookTwoDayAppointment?.day1 ?? '', driver)}
              fill={true}
              intent="none"
              target="_blank"
              rel="noreferrer"
            >
              <FormattedMessage
                defaultMessage="Book City Knowledge Test"
                id="onboarding_intro_city_test_book"
                description="Book City Knowledge Test button"
              />
            </AnchorButton>
          </div>
        </div>
      )}
      {region === CountryCode.France && (
        <div className={cn(s.buttons, s.bookingAction)}>
          <AnchorButton
            href={getBookingLink(links.bookPreAssessment, driver)}
            fill={true}
            intent="none"
            target="_blank"
            rel="noreferrer"
          >
            <FormattedMessage
              defaultMessage="Book Your Spot"
              id="todo_academy_card_pre_assessment_cta"
              description="Todo list academy card CTA button"
            />
          </AnchorButton>
        </div>
      )}
    </>
  );
};

export { AccountBlockedError };
